'use client';

interface FullScreenLoaderProps {
  /** Spinner border color (Tailwind class or hex) */
  spinnerColor?: string;
  /** Loading text color */
  textColor?: string;
  /** Loading text */
  text?: string;
}

/**
 * Full screen loading indicator for Flow Quiz pages
 */
export default function FullScreenLoader({
  spinnerColor = 'border-[#FA6467]',
  textColor,
  text = 'Loading...',
}: FullScreenLoaderProps) {
  // If spinnerColor is a hex value, use inline style
  const isHexColor = spinnerColor.startsWith('#') || spinnerColor.startsWith('rgb');

  return (
    <div className="h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        <div
          className={`w-12 h-12 border-4 border-t-transparent rounded-full animate-spin ${
            isHexColor ? '' : spinnerColor
          }`}
          style={isHexColor ? { borderColor: spinnerColor, borderTopColor: 'transparent' } : undefined}
        />
        <div className="text-gray-500" style={textColor ? { color: textColor } : undefined}>
          {text}
        </div>
      </div>
    </div>
  );
}
